module.exports = __webpack_public_path__ + "static/media/dai.ac10d2f3.svg";